'use client';

import React from "react";
import Icon from "../Icon/Icon";
import { iconSizes } from "../Icon/IconWrap/IconWrap";

interface Props {
    size?: keyof typeof iconSizes;
    color?: "" | "text-midnight-500" | "text-content-accent";
    className?: string;
}

const Spinner = ({ size = "medium", className, color = "text-midnight-500" }: Props) => (
    <Icon
        data-testid="spinner"
        icon="spinner"
        size={size}
        className={`${className} ${color} animate-spin-clockwise-infinite`}
    />
);

export default Spinner;
